import React from 'react';
import { APP_CONTAINER_ROUTES } from '@/navigators/routes';
import { AppContainerStackParams } from '@/navigators/types';
import { PaymentLinkDetailComponent } from '@/components/payments/payment-link-detail-component';
import { StackScreenProps } from '@react-navigation/stack';

export type Props = StackScreenProps<
  AppContainerStackParams,
  APP_CONTAINER_ROUTES.PaymentLinkDetail
>;

export const PaymentLinkDetailScreen: React.FC<Props> = ({ route }) => {
  const { paymentLinkUUID, restaurantUUID, supplierUUID } = route.params;
  return (
    <PaymentLinkDetailComponent
      paymentLinkUUID={paymentLinkUUID}
      restaurantUUID={restaurantUUID}
      supplierUUID={supplierUUID}
    />
  );
};
